import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    img: "https://codingyaar.com/wp-content/uploads/square-headshot-1.png",
    feedback:
      "The team at Innovate Solutions exceeded our expectations with their innovative approach and exceptional service. Highly recommended!",
    name: "Sophia Carter",
    title: "CTO, Innovate Solutions"
  },
  {
    img: "https://codingyaar.com/wp-content/uploads/square-headshot-2.png",
    feedback:
      "Partnering with Bright Future Tech has been a game-changer for our business. Their expertise and support are unmatched.",
    name: "Michael Anderson",
    title: "Founder, Bright Future Tech"
  },
  {
    img: "https://codingyaar.com/wp-content/uploads/bootstrap-profile-card-image.jpg",
    feedback:
      "We are thrilled with the results! SkyHigh Analytics provided insights that helped us scale our operations effectively.",
    name: "Emily Davis",
    title: "COO, SkyHigh Analytics"
  }
  //   {
  //     img: "https://codingyaar.com/wp-content/uploads/square-headshot-1.png",
  //     feedback:
  //       "Working with Agile Innovators was an absolute pleasure. Their attention to detail and commitment to quality were remarkable.",
  //     name: "James Taylor",
  //     title: "CEO, Agile Innovators"
  //   }
  //   {
  //     img: "https://codingyaar.com/wp-content/uploads/square-headshot-2.png",
  //     feedback:
  //       "The level of professionalism and expertise demonstrated by TechEdge Consulting was outstanding. They truly care about their clients.",
  //     name: "Olivia Johnson",
  //     title: "Managing Director, TechEdge Consulting"
  //   },
  //   {
  //     img: "https://codingyaar.com/wp-content/uploads/bootstrap-profile-card-image.jpg",
  //     feedback:
  //       "I can’t say enough good things about the team at Visionary Creatives. They transformed our ideas into reality with their innovative solutions.",
  //     name: "David Wilson",
  //     title: "Creative Director, Visionary Creatives"
  //   },
  //   {
  //     img: "https://codingyaar.com/wp-content/uploads/square-headshot-1.png",
  //     feedback:
  //       "Peak Performance Consulting delivered results that surpassed our expectations. Their strategic insights were invaluable.",
  //     name: "Emma Brown",
  //     title: "Head of Operations, Peak Performance Consulting"
  //   }
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnFocus: true,
  pauseOnDotsHover: true,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

const Clients = () => {
  return (
    <div className="bg-gray-100 pb-14 pt-1">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold text-center text-[#377c7d] mb-8">
          Testimonials
        </h2>
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="px-4">
              <div className="bg-white shadow-lg rounded-lg p-6 text-center">
                <div className="text-gray-400 text-5xl mb-4">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="text-gray-600 italic mb-4">
                  {testimonial.feedback}
                </p>
                <div className="flex items-center justify-center">
                  <img
                    src={testimonial.img}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full mr-4"
                  />
                  <div className="text-left">
                    <h5 className="font-bold text-gray-800">
                      {testimonial.name}
                    </h5>
                    <p className="text-gray-500 text-sm">{testimonial.title}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Clients;
